import{jsx as o}from"react/jsx-runtime";import{createPortal as r}from"react-dom";import{keyframes as t,styled as e}from"styled-components";import{Backdrop as i}from"../Backdrop/Backdrop.mjs";const m=t`
  from { transform:rotate(0deg); }
  to { transform:rotate(360deg); }
`,n=e.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: solid 6px #66666610;
  border-bottom-color: #ffffff;
  position: relative;
  animation: ${m} 1s infinite linear;
`;function d(){return r(o(i,{children:o(n,{})}),document.body)}export{d as BackdropSpinner};
